/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { Config } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface ConfigServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Deletes a value in a generic way
     * Deletes a value in a generic way to let the user control the configuration
     * @param schemaName schema of the database
     * @param tableName tableName of the data table
     * @param id ID of the data table value
     */
    deleteValueById(schemaName: string, tableName: string, id: string, extraHttpRequestParams?: any): Observable<object>;

    /**
     * Returns configurations list
     * Returns general list
     */
    getAllConfigs(extraHttpRequestParams?: any): Observable<Array<Config>>;

    /**
     * Returns configurations by ID
     * Returns configuration by ID
     * @param id ID of the configuration
     */
    getConfigById(id: number, extraHttpRequestParams?: any): Observable<Config>;

    /**
     * Returns configurations by tableName
     * Returns configuration by tableName
     * @param tableName tableName of the configuration
     */
    getConfigByTableName(tableName: string, extraHttpRequestParams?: any): Observable<Config>;

    /**
     * Returns column columns by tableName
     * Returns column columns by tableName
     * @param tableName tableName of the column configuration
     */
    getConfigColumnByTableName(tableName: string, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Returns a list of the configurable data
     * Returns a list of the configurable data that the user is able to manipulate
     * @param schemaName schema of the database
     * @param tableName tableName of the data table
     */
    getList(schemaName: string, tableName: string, extraHttpRequestParams?: any): Observable<Array<object>>;

    /**
     * Creates a value in a generic way
     * Creates a value in a generic way to let the user control the configuration
     * @param schemaName schema of the database
     * @param tableName tableName of the data table
     * @param requestBody Generic object that needs to be added
     */
    postValue(schemaName: string, tableName: string, requestBody: { [key: string]: object; }, extraHttpRequestParams?: any): Observable<{ [key: string]: object; }>;

    /**
     * Updates a value in a generic way
     * Update a value in a generic way to let the user control the configuration
     * @param schemaName schema of the database
     * @param tableName tableName of the data table
     * @param id ID of the data table value
     * @param requestBody Generic object that needs to be added
     */
    updateValue(schemaName: string, tableName: string, id: string, requestBody: { [key: string]: object; }, extraHttpRequestParams?: any): Observable<{ [key: string]: object; }>;

}
